module.exports = __webpack_public_path__ + "img/imgStep06.25794672.png";